// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const EndpointExpectedResponseVerbSchema = z.enum(['CREATE','DELETE','UPDATE','NONE'] as const);

export type EndpointExpectedResponseVerbType = `${z.infer<typeof EndpointExpectedResponseVerbSchema>}`

export default EndpointExpectedResponseVerbSchema;
